.root {
  margin-bottom: var(--spacingLg);
}
